import styled from 'styled-components'
import ArtboardRasterized from './rasterized'

export const Container = styled.div`
    position: relative;
`

export const RasterizedCanvas = styled(ArtboardRasterized)`
    display: block;
    border-radius: inherit;
    height: 100%;
    left: 0;
    position: absolute;
    top: 0;
    width: 100%;
`
